<div [formGroup]="form" class="container">
  <div class="row">
    <div class="col-6">
      @if (form.value.accountType === 'CONSUMER') {
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="accountHolderFirstName" [readonly]="isViewMode" />
            <mat-error>
              @if (form.controls.accountHolderFirstName.hasError('required')) {
                First name is required.
              }
              @if (form.controls.accountHolderFirstName.hasError('maxlength')) {
                First name cannot exceed 20 characters.
              }
              @if (form.controls.accountHolderFirstName.hasError('pattern')) {
                Only letters, spaces, apostrophes, hyphens and # allowed.
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="accountHolderLastName" [readonly]="isViewMode" />
            <mat-error>
              @if (form.controls.accountHolderLastName.hasError('required')) {
                Last name is required.
              }
              @if (form.controls.accountHolderLastName.hasError('maxlength')) {
                Last name cannot exceed 20 characters.
              }
              @if (form.controls.accountHolderLastName.hasError('pattern')) {
                Only letters, spaces, apostrophes, hyphens and # allowed.
              }
            </mat-error>
          </mat-form-field>
        </div>
      } @else {
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="accountHolderName" [readonly]="isViewMode" />
            <mat-error>
              @if (form.controls.accountHolderName.hasError('required')) {
                Account holder name is required.
              }
              @if (form.controls.accountHolderName.hasError('minlength')) {
                Name must be at least 8 characters.
              }
              @if (form.controls.accountHolderName.hasError('maxlength')) {
                Name cannot exceed 40 characters.
              }
              @if (form.controls.accountHolderName.hasError('pattern')) {
                Only letters, numbers, spaces, &amp;, apostrophes and # allowed.
              }
            </mat-error>
          </mat-form-field>
        </div>
      }
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Account Number</mat-label>
          <input matInput #accountInput formControlName="account" [readonly]="isViewMode" />
          <mat-error>
            @if (form.controls.account.hasError('required')) {
              Account Number is required.
            }
            @if (form.controls.account.hasError('minlength')) {
              Must be at least 5 digits.
            }
            @if (form.controls.account.hasError('maxlength')) {
              Cannot exceed 17 digits.
            }
            @if (form.controls.account.hasError('pattern')) {
              Only numbers allowed.
            }
            @if (form.controls.account.hasError('achInvalid')) {
              {{ invalidMessage }}
            }
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>ABA Routing Number</mat-label>
          <input matInput #routingInput formControlName="abaRoute" [readonly]="isViewMode" [mask]="routingMask" />
          <mat-error>
            @if (form.controls.abaRoute.hasError('required')) {
              Routing Number is required.
            }
            @if (form.controls.abaRoute.hasError('minlength') || form.controls.abaRoute.hasError('maxlength')) {
              Must be exactly 9 digits.
            }
            @if (form.controls.abaRoute.hasError('pattern')) {
              Only numbers allowed.
            }
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Confirm Account Number</mat-label>
          <input matInput formControlName="confirmAccount" [readonly]="isViewMode" />
          <mat-error>
            @if (form.controls.confirmAccount.hasError('required')) {
              Please confirm Account Number.
            }
            @if (form.controls.confirmAccount.hasError('accountMismatch')) {
              Account Numbers do not match.
            }
            @if (form.controls.confirmAccount.hasError('pattern')) {
              Only numbers allowed.
            }
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" [readonly]="isViewMode" />
          <mat-error>
            @if (form.controls.description.hasError('maxlength')) {
              Description cannot exceed 25 characters.
            }
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="form-control">
        <mat-form-field appearance="outline">
          <mat-label>Account Type</mat-label>
          <mat-select formControlName="accountType" [disabled]="isViewMode">
            <mat-option value="CONSUMER">Personal Account</mat-option>
            <mat-option value="BUSINESS">Business Account</mat-option>
          </mat-select>
          <mat-error>
            @if (form.controls.accountType.hasError('required')) {
              Account type is required.
            }
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="form-control">
        <div class="container">
          @if (isAchInvalid == false) {
            *Required Fields
          } @else {
            <mat-error>
              {{ invalidMessage }}
            </mat-error>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-control">
        @if (!hideDefaultOption) {
          <mat-slide-toggle formControlName="isDefault" [disabled]="isViewMode" style="margin-left: 48px">
            Set as default
          </mat-slide-toggle>
        }
      </div>
    </div>
  </div>
</div>
